import { useQuery } from '@apollo/react-hooks';
import {
  type GetResearchExperience,
  type ResearchExperienceFormData,
} from '../../../components/ApplicationForm/ResearchExperience/types';
import { GET_RESEARCH_EXPERIENCE } from './GET_RESEARCH_EXPERIENCE.gql';
export const useGetResearchExperienceFormData = (
  id: string,
): GetResearchExperience => {
  const {
    data: researchExperienceData,
    loading,
    error,
  } = useQuery(GET_RESEARCH_EXPERIENCE, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  const researchExperienceFormData: ResearchExperienceFormData =
    researchExperienceData?.researchExperience ?? {};
  return { researchExperienceFormData, loading, error };
};
